import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Link from 'Component/Link';
import {
    ORDER_STATUS_ESTIMATED_DELIVERY,
    ORDER_STATUS_ESTIMATED_DROP
} from 'Component/MyAccountOrderTimeline/MyAccountOrderTimeline.config';
import { OrderTimelineType, OrderType } from 'Type/Order.type';

import './MyAccountOrderTimeline.style';

/** @namespace PeggysagePwa/Component/MyAccountOrderTimeline/Component */
export class MyAccountOrderTimelineComponent extends PureComponent {
    static propTypes = {
        currentStoreCode: PropTypes.string.isRequired,
        timeline: OrderTimelineType.isRequired,
        trackingStepStatus: PropTypes.string.isRequired,
        order: OrderType.isRequired
    };

    renderStepDate(item) {
        const { currentStoreCode } = this.props;
        const { date, date_estimated } = item;

        if (!date && !date_estimated) {
            return null;
        }

        const dateText = date_estimated
            || new Date(date).toLocaleDateString(currentStoreCode.substr(0, 2).toLowerCase());

        return (
            <div block="MyAccountOrderTimeline" elem="StepDate">
                { dateText }
            </div>
        );
    }

    renderTrackingLink(tracking) {
        const { tracking_url, number } = tracking;

        return (
            <Link
              block="MyAccountOrderTimeline"
              elem="TrackingLink"
              to={ tracking_url }
              target="_blank"
              key={ number }
            >
                { __('Track my parcel') }
            </Link>
        );
    }

    renderTrackingLinks(item) {
        const { status } = item;
        const { order: { shipments }, trackingStepStatus } = this.props;

        if (status !== trackingStepStatus || !shipments) {
            return null;
        }

        const shipmentsWithTracking = shipments.filter((shipment) => shipment.tracking);

        if (!shipmentsWithTracking.length) {
            return null;
        }

        return (
            <div block="MyAccountOrderTimeline" elem="Shipments">
                { shipmentsWithTracking.map((shipment) => {
                    const { tracking: trackings, number } = shipment;

                    if (!trackings) {
                        return null;
                    }

                    return (
                        <div block="MyAccountOrderTimeline" elem="Shipment" key={ number }>
                            <div block="MyAccountOrderTimeline" elem="ShipmentLabel">
                                { __('Shipment #%s:', number) }
                            </div>
                            <div block="MyAccountOrderTimeline" elem="TrackingLinks">
                                { trackings.map(this.renderTrackingLink.bind(this)) }
                            </div>
                        </div>
                    );
                }) }
            </div>
        );
    }

    renderStepEstimateMessage(item) {
        const { status, date_estimated } = item;

        if (![ORDER_STATUS_ESTIMATED_DROP, ORDER_STATUS_ESTIMATED_DELIVERY].includes(status) || !date_estimated) {
            return null;
        }

        return (
            <div block="MyAccountOrderTimeline" elem="StepEstimateMessage">
                { __('Ces délais sont fournis à titre indicatif.') }
                <br />
                { __('Ils sont susceptibles de varier.') }
            </div>
        );
    }

    renderStep(item, key) {
        const { status, label, active } = item;

        return (
            <div
              block="MyAccountOrderTimeline"
              elem="Step"
              mods={ { isActive: !!active } }
              key={ key }
            >
                <div block="MyAccountOrderTimeline" elem="StepIcon">
                    <span className={ status } />
                </div>
                <div block="MyAccountOrderTimeline" elem="StepContent">
                    { this.renderStepDate(item) }
                    <div block="MyAccountOrderTimeline" elem="StepLabel">
                        { label }
                    </div>
                    { this.renderTrackingLinks(item) }
                    { this.renderStepEstimateMessage(item) }
                </div>
            </div>
        );
    }

    renderContent() {
        const { timeline } = this.props;

        return (
            <div block="MyAccountOrderTimeline" elem="Steplist">
                { timeline.map(this.renderStep.bind(this)) }
            </div>
        );
    }

    render() {
        const { timeline } = this.props;

        if (!timeline || !timeline.length) {
            return null;
        }

        return (
            <div block="MyAccountOrderTimeline">
                { this.renderContent() }
            </div>
        );
    }
}

export default MyAccountOrderTimelineComponent;
